import type { Cell, MiniResult } from '@tentactoe/engine';
import type { Theme } from '../theme';

interface MarkProps {
  readonly value: Cell | MiniResult;
  readonly theme: Theme;
  readonly className?: string;
}

/** Renders a cell or mini-board value using the active theme's symbol set. */
export function Mark({ value, theme, className = 'w-5 h-5' }: MarkProps) {
  const { symbols, classes } = theme;

  switch (value) {
    case 'X':
      return <symbols.X className={`${className} ${classes.turnX}`} />;
    case 'O':
      return <symbols.O className={`${className} ${classes.turnO}`} />;
    case 'draw':
      return <symbols.drawn className={`${className} text-gray-500`} />;
    default:
      return <symbols.empty className={`${className} text-gray-400`} />;
  }
}
